import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import UserContext from '../../../contexts/UserContext';
import {
    Tab,
    TabProps,
    Dimmer,
    Loader,
    Button,
    Dropdown,
    Checkbox,
    Icon,
    Input,
    Select,
    Divider,
    Form,
    Grid,
    Image,
    Modal
} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { updateActivity, saveActivity, deleteActivity, listCommunityActivities } from '../../../services/community';

import { listActivities, getSignedImageUrls } from '../../../services/dailyactivities'
import { fetchAttendeeObj, updateAttendeeObj, createAttendeeObj } from '../../../services/activityAttendees'

import './style.less';
import DailyActivity from './dailyActivity';
import DailyActivityForm from './dailyActivityForm';

import ActivityItemsListPane from './ActivityItemsListPane'

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import { DailyActivityDatatype } from './dailyactivity.d'

// Change removed status to deletion of attendee object? - ask Matt about this

const DailyActivities = () => {
    const [lastUpdated, setLastUpdated] = useState(Date.now());
    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
            profile: { _id: userId },
        },
    } = useContext(UserContext);

    const [menuDate, setMenuDate] = useState(new Date());
    const [activityList, setActivityList] = useState<DailyActivityDatatype[]>([]);
    const [historyActivities, setHistoryActivities] = useState<any[]>([])
    const [activityImageUrls, setActivityImageUrls] = useState<any[]>([])
    const [loading, setLoading] = useState(true);

    const [activityMainTabIndex, setActivityMainTabIndex] = useState(0)

    const [showActivityDetail, setShowActivityDetail] = useState<boolean>(false)
    const [selectedActivity, setSelectedActivity] = useState<DailyActivityDatatype | undefined>(undefined)
    const [selectedAttendeeObj, setSelectedAttendeeObj] = useState<any | undefined>(undefined)

    const saveActivityItem = async (menuItem) => {
        try {
            await saveActivity(userId, menuItem);
            fetchActivities();
        } catch (e) {
            console.log(e);
        }
    };

    const updateActivityItem = async (activity) => {
        try {
            await updateActivity(userId, activity);
            fetchActivities();
        } catch (e) {
            console.log(e);
        }
    };

    const deleteActivityItem = async (activityId) => {
        try {
            await deleteActivity(userId, activityId);
            fetchActivities();
        } catch (e) {
            console.log(e);
        }
    };

    const fetchActivities = async () => {
        setLoading(true);
        try {
            if (process.env.REACT_APP_PLATFORM === 'community') {
                const selectedResident = listOfResidents[activeRegistrantsIndexes[0]]
                if (selectedResident.Facility) {
                    const facilityId = selectedResident.Facility
                    const activityListLocal = await listActivities(facilityId)
                    setActivityList(activityListLocal)
                    const fetchAttendeesResponse = await fetchAttendeeObj(undefined, selectedResident._id, selectedResident.Facility)
                    const activityAttendeeObjsListlocal = fetchAttendeesResponse.Result.Content.Result

                    const getRelatedActivityAttendeeObj = (activity) => {
                        return activityAttendeeObjsListlocal.find(attendeeObj => {
                            return attendeeObj.activityId === activity._id
                        })
                    }
                    const historyActivitiesLocal:any[] = []
                    const activityListLocalCopy = [...activityListLocal]
                    for (let ctr = 0; ctr < activityListLocal.length; ++ctr) {
                        if (activityListLocal[ctr].timestamp < Date.now()) {
                            const relatedActivityAttendeeObj = getRelatedActivityAttendeeObj(activityListLocalCopy[ctr])
                            if (relatedActivityAttendeeObj) {
                                activityListLocalCopy[ctr].status = relatedActivityAttendeeObj.status
                                historyActivitiesLocal.push(activityListLocalCopy[ctr])
                            }
                        }
                    }
                    setHistoryActivities(historyActivitiesLocal)
                } else {
                    console.log('This is not a facility resident: ', selectedResident)
                    setActivityList([])
                    setHistoryActivities([])
                }
            } else {
                //Extend this to take page number
                const activityList = await listCommunityActivities(userId);
                console.log(activityList);
                setActivityList(activityList);
            }
        } catch (e) {
            console.log(e);
        }
        setLoading(false);
    };

    const handleMonthChange = async (payload) => {

    }

    const setSelectedActivityAndAttendeeObjAndPhotos = async (clickedActivity) => {
        const selectedResident = listOfResidents[activeRegistrantsIndexes[0]]

        const attendeeObjResponse = await fetchAttendeeObj(clickedActivity && clickedActivity._id, selectedResident._id, selectedResident.Facility)
        const attendeeObj = attendeeObjResponse.Result.Content.Result[0]

        if (attendeeObj) {
            setSelectedAttendeeObj(attendeeObj)
        }

        // Get urls of photos
        if (clickedActivity && clickedActivity.imageFilenames) {
            const imageUrlsRequestBody = {
                activityId: clickedActivity && clickedActivity._id,
                fileNames: clickedActivity && clickedActivity.imageFilenames
            }
            const imageUrlsResponse = await getSignedImageUrls(selectedResident.Facility, imageUrlsRequestBody)
            const imageUrls = imageUrlsResponse.Result.Content
            setActivityImageUrls(imageUrls)
        } else {
            setActivityImageUrls([])
        }
    }

    const handleHistoryActivityClick = async (clickedActivity) => {
        setLoading(true)

        setShowActivityDetail(true)
        setSelectedActivity(clickedActivity)

        await setSelectedActivityAndAttendeeObjAndPhotos(clickedActivity)

        setLoading(false)
    }

    const handleEventClick = async (payload) => {
        setLoading(true)

        setShowActivityDetail(true)
        const clickedActivity = activityList.find(activity => {
            return activity._id === payload.event._def.publicId
        })
        setSelectedActivity(clickedActivity)
        
        await setSelectedActivityAndAttendeeObjAndPhotos(clickedActivity)

        setLoading(false)
    }

    useEffect(() => {
        fetchActivities()
    }, [activeRegistrantsIndexes]);

    const activityMainPanes = [
        {
            menuItem: 'Calendar',
            render: () => (
                <div className="menu-calendar-view">
                    <FullCalendar
                        plugins={[dayGridPlugin, interactionPlugin]}
                        initialView="dayGridMonth"
                        events={[
                            ...activityList.map((event) => {
                                return {
                                    title: event.text ? event.text.replace(/(<([^>]+)>)/gi, '') : '',
                                    start: event.timestamp,
                                    id: event._id,
                                }
                            }),
                        ]}
                        datesSet={handleMonthChange}
                        eventClick={handleEventClick}
                    />
                </div>
            )
        },
        {
            menuItem: 'History',
            render: () => (
                <ActivityItemsListPane
                    loading={loading}
                    // listItemFilter={this.state.activityFilter}
                    // setListItemDateFilter={this.setActivityDateFilter.bind(this)}
                    // isSaving={this.state.isSaving}
                    isFetching={loading}
                    // clearDateFilter={this.clearDateFilter.bind(this)}
                    listItems={historyActivities}
                    onActivityListItemClick={(clickedActivity) => {
                        handleHistoryActivityClick(clickedActivity)
                    }}
                    // getPaginatedListItem={this.getPaginatedActivity.bind(this)}
                    // deleteListItem={this.deleteActivity.bind(this)}
                    // editListItem={this.editActivity.bind(this)}
                    // copyListItem={this.copyActivity.bind(this)}
                    // cancelEditListItem={this.cancelEditActivity.bind(this)}
                    // handleSubmit={this.handleSubmit.bind(this)}
                    // handleUpdate={this.handleUpdate.bind(this)}
                    // sourcePage="DailyActivities"
                    // passAudioBlob={this.passAudioBlob.bind(this)}
                />
            )
        }
    ]

    const handleActivityTabChange = (event, data) => {
        setActivityMainTabIndex(data.activeIndex)
    }

    const ActivityMainComponent = () => {
       return (
            <>
                {process.env.REACT_APP_PLATFORM === 'community'
                ?   <h2>Activities</h2>
                :   <h2>Community Activities</h2>
                }

                {/* <DailyActivityForm
                    activity={{ startTime: Date.now() }}
                    saveHandler={saveActivityItem}
                    cancelHandler={undefined}
                /> */}
                {/* <Divider /> */}

                <Tab
                    activeIndex={activityMainTabIndex}
                    className="views-tab"
                    menu={{ secondary: true, pointing: true }}
                    panes={activityMainPanes}
                    onTabChange={handleActivityTabChange}
                />

                {/* <div className="menu-calendar-view">
                    <FullCalendar
                        plugins={[dayGridPlugin, interactionPlugin]}
                        initialView="dayGridMonth"
                        events={[
                            ...activityList.map((event) => {
                                return {
                                    title: event.text ? event.text.replace(/(<([^>]+)>)/gi, '') : '',
                                    start: event.timestamp,
                                    id: event._id,
                                }
                            }),
                        ]}
                        datesSet={handleMonthChange}
                        eventClick={handleEventClick}
                    />
                </div> */}
            </>
       )
    }

    const handleAttendOrCancelAttend = async (isChecked) => {

        setLoading(true)

        const selectedResident = listOfResidents[activeRegistrantsIndexes[0]]
        let newStatus = ''
        if (selectedAttendeeObj) {
            if (isChecked) {
                newStatus = 'intend_attend'
            } else {
                newStatus = 'removed'
            }
            const updateAttendeeResponse = await updateAttendeeObj(selectedResident.Facility, selectedAttendeeObj._id, newStatus)
            setSelectedAttendeeObj({
                ...selectedAttendeeObj,
                status: isChecked ? 'intend_attend' : 'removed'
            })
        } else {
            const newAttendeeObj = {
                Facility: selectedResident.Facility,
                activityId: selectedActivity && selectedActivity._id,
                registrantId: selectedResident._id,
                registrant: {FirstName: selectedResident.FirstName, LastName: selectedResident.LastName},
                status: 'intend_attend'
            }
            const createNewAttendeeResponse = await createAttendeeObj(
                selectedResident.Facility,
                newAttendeeObj
            )
            setSelectedAttendeeObj({
                _id: createNewAttendeeResponse.Result.Content,
                ...newAttendeeObj
            })
        }

        setLoading(false)
    }

    const AttendToggle = () => {
        let checkboxLabel='', checkboxChecked=false, checkboxDisabled=false
        if (selectedActivity && selectedActivity.timestamp < Date.now()) {
            checkboxLabel = 'Activity completed'
            checkboxDisabled = true
            if (selectedAttendeeObj && ['intend_attend', 'attended'].includes(selectedAttendeeObj.status)) {
                checkboxChecked = true
            } else {
                checkboxChecked = false
            }
        } else {
            if (selectedAttendeeObj) {
                if (selectedAttendeeObj.status === 'intend_attend') {
                    checkboxLabel = 'Attending'
                    checkboxChecked = true
                    checkboxDisabled = false
                } else if (selectedAttendeeObj.status === 'attended') {
                    checkboxLabel = 'Attended'
                    checkboxChecked = true
                    checkboxDisabled = true
                } else if (selectedAttendeeObj.status === 'removed') {
                    checkboxLabel = 'Not attending'
                    checkboxChecked = false
                    checkboxDisabled = false
                }
            } else {
                checkboxLabel = 'Not attending'
                checkboxChecked = false
                checkboxDisabled = false
            }
        }
        
        return (
            <Checkbox
                toggle
                disabled={checkboxDisabled}
                label={checkboxLabel}
                checked={checkboxChecked}
                onChange={(e, data) => handleAttendOrCancelAttend(data.checked)}
            />
        )
    }

    const PhotoModal = ({ imageUrl, onModalOpen, onModalClose, isPhotoModalOpen, showPreviousPhoto, showNextPhoto, disableModalPreviousButton, disableModalNextButton }) => {
        return (
            <Modal
                onClose={onModalClose}
                onOpen={onModalOpen}
                open={isPhotoModalOpen}
            >
                <Modal.Content image>
                    <Image size='large' src={imageUrl}/>
                </Modal.Content>
                <Modal.Actions>
                    <Button 
                        icon='chevron left'
                        onClick={showPreviousPhoto} disabled={disableModalPreviousButton}
                    />
                    <Button 
                        icon='chevron right'
                        onClick={showNextPhoto} disabled={disableModalNextButton}
                    />
                </Modal.Actions>
            </Modal>
        )
    }

    const PhotoGrid = () => {

        const [isPhotoModalOpen, setIsPhotoModalOpen] = useState<boolean>(false)
        const [photoModalImageUrl, setPhotoModalImageUrl] = useState<any | undefined>()
        const [currentPhotoIndex, setCurrentPhotoIndex] = useState<number | undefined>()
        
        const getPhotoRows = (photoUrls, maxCols) => {
            let photoRows:any[] = []
            let row:any[] = []
            const quotient = Math.floor(photoUrls.length/maxCols)
            for (let rowCtr = 0; rowCtr < quotient; ++rowCtr) {
                row = []
                for (let colCtr = 0; colCtr < maxCols; ++colCtr) {
                    row.push(photoUrls[rowCtr*maxCols + colCtr])
                }
                photoRows.push(row)
            }

            const remainder = photoUrls.length % maxCols
            row = []
            for (let ctr = 0; ctr < remainder; ++ctr) {
                row.push(photoUrls[photoUrls.length - ctr - 1])
            }
            photoRows.push(row)

            return photoRows
        }

        const showPreviousPhoto = () => {
            const localCurrentPhotoIndex = getCurrentPhotoIndex(activityImageUrls, photoModalImageUrl)
            if (localCurrentPhotoIndex !== 0) {
                setPhotoModalImageUrl(activityImageUrls[localCurrentPhotoIndex - 1])
                setCurrentPhotoIndex(localCurrentPhotoIndex - 1)
            }
        }

        const showNextPhoto = () => {
            const localCurrentPhotoIndex = getCurrentPhotoIndex(activityImageUrls, photoModalImageUrl)
            if (localCurrentPhotoIndex !== (activityImageUrls.length - 1)) {
                setPhotoModalImageUrl(activityImageUrls[localCurrentPhotoIndex + 1])
                setCurrentPhotoIndex(localCurrentPhotoIndex + 1)
            }
        }

        const getCurrentPhotoIndex = (imageUrls, currentUrl) => {
            return imageUrls.findIndex(url => {
                return url === currentUrl
            })
        }

        if (activityImageUrls && activityImageUrls.length) {
            return (
                <>
                    <Grid>
                        {getPhotoRows(activityImageUrls, 4).map((row, rowIndex) => {
                            return (
                                <Grid.Row columns={4} key={'row-'+rowIndex}>
                                    {row.map(imageUrl => {
                                        return (
                                            <Grid.Column 
                                                key={imageUrl} 
                                                onClick={e => {
                                                    setPhotoModalImageUrl(e.target.src)
                                                    setCurrentPhotoIndex(getCurrentPhotoIndex(activityImageUrls, e.target.src))
                                                    setIsPhotoModalOpen(true)
                                                }}
                                            >
                                                <Image rounded src={imageUrl} />
                                            </Grid.Column>
                                        )
                                    })}
                                </Grid.Row>
                            )
                        })}
                    </Grid>
                    <PhotoModal
                        imageUrl={photoModalImageUrl}
                        onModalOpen={() => {
                            setIsPhotoModalOpen(true)
                        }}
                        onModalClose={() => {
                            setIsPhotoModalOpen(false)
                        }}
                        isPhotoModalOpen={isPhotoModalOpen}
                        showPreviousPhoto={showPreviousPhoto}
                        showNextPhoto={showNextPhoto}
                        disableModalPreviousButton={currentPhotoIndex === 0}
                        disableModalNextButton={currentPhotoIndex === (activityImageUrls.length - 1)}
                    />
                </>
            )
        }
        return (
            <p style={{color: 'gray'}}>No photos yet</p>
        )
    }

    const ActivityDetailComponent = () => {
        return (
            <>
                <Button 
                    basic
                    size='small'
                    onClick={() => {
                        setLoading(true)
                        
                        setShowActivityDetail(false)
                        setSelectedActivity(undefined)
                        
                        setLoading(false)
                    }}
                    content='Back to all activities'
                    icon='chevron left'
                />
                <h2>{selectedActivity && selectedActivity.text}</h2>
                
                {AttendToggle()}

                <Divider />

                <h2>Photos</h2>
                <PhotoGrid />
            </>
        )
    }

    return (
        <div className=" food-menu">
            {/* <MenuItemForm menuItem={ {dateString: new Date(), category: "breakfast"}} saveHandler={saveMenu}/> */}
            <Dimmer active={loading} inverted>
                <Loader active={loading} />
            </Dimmer>
            {showActivityDetail
            ? ActivityDetailComponent()
            : ActivityMainComponent()
            }

            {/* <h2>Create Community Activity</h2> */}
           
            

            {/* {activityList &&
                activityList.length &&
                activityList.map((activity) => {
                    const { _id } = activity;
                    return (
                        <DailyActivity
                            activity={activity}
                            key={_id}
                            updateHandler={updateActivityItem}
                            deleteHandler={deleteActivityItem}
                        />
                    );
                })} */}
            {/* {menuList()} */}
        </div>
    );
};

export default DailyActivities;
